<template>
  <div
    class="hhh he_border1"
    @click="goDetail('newsdetail')"
    :style="
      'background: #fff url(' + project.thumbnail + ') center center no-repeat;'
    "
  >
    <!-- <a href="javascript:void(0);"> -->
    <!-- <img :src="project.thumbnail" alt class="he_border1_img" /> -->
    <div class="he_border1_caption">
      <div class="he_border1_caption_h hhhtitle">{{ project.title }}</div>
      <div class="he_border1_caption_p hhhdate">
        <div class="hhhflex">
          <span class="zyjm-shijian"></span>
          {{ project.created_at }}
        </div>
        <div class="hhhflex">
          <span class="zyjm-liulanliang"></span>
          {{ project.view_num }}
        </div>
      </div>
      <a class="he_border1_caption_a" href="#"></a>
    </div>
    <!-- <div class="hhhtitle">{{project.title}}</div>
      <div class="hhhdate">
        <div class="hhhflex">
          <span class="zyjm-shijian"></span>
          {{project.updated_at}}
        </div>
        <div class="hhhflex">
          <span class="zyjm-liulanliang"></span>
          {{project.view_num}}
        </div>
    </div>-->
    <!-- </a> -->
  </div>
</template>
<script>
export default {
  name: "project",
  props: {
    project: {
      type: Object,
    },
  },
  data() {
    return {
      img: "../../static/新闻列表页2.jpg",
    };
  },
  methods: {
    goDetail(name) {
      // this.$router.push({ name, params: { id: this.project.id } })
      this.$router.push({
        name: "newsdetail",
        params: { id: this.project.id },
      });
      window.second = true;
      // this.$router.push({ name })
      // window.location.reload()
    },
  },
};
</script>

<style scoped>
.hhh {
  width: 100%;
  max-width: 29%;
  position: relative;
  margin: 0 2% 0.4rem 2%;
  background-size: cover;
}
.hhh img {
  height: 100%;
}
.hhhtitle {
  position: absolute;
  text-align: center;
  width: 100%;
  top: 1rem;
  font-size: 0.2rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 0 0.2rem;
  font-size: 0.24rem;
}
.hhhdate {
  position: absolute;
  width: 100%;
  top: 2rem;
  font-size: 0.2rem;
  display: flex;
  padding: 0 0.4rem;
  justify-content: space-between;
}
.hhhflex {
  display: flex;
  font-size: 0.14rem;
  line-height: 0.3rem;
}
.hhhflex span {
  line-height: 0.3rem;
  font-size: 0.14rem;
}
.he_border1 {
  background: #ff6900;
  width: 100%;
  max-width: 29%;
  /* flex: 0 0 29%; */
  /* height: 220px; */
  min-height: 260px;
  position: relative;
  margin: 0 2% 0.4rem 2%;
  padding: 0;
  /* border: 1px solid #000; */
  position: relative;
  box-sizing: border-box;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -ms-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  overflow: hidden;
}

.he_border1 .he_border1_img {
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  position: relative;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -ms-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  opacity: 1;
  overflow: hidden;
}

/* .he_border1:hover .he_border1_img {
  position: absolute;
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
  opacity: 0.2;
} */

.he_border1 .he_border1_caption {
  color: #fff;
  padding: 0;
  margin: 0;
  -moz-backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -ms-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  overflow: hidden;
}

.he_border1 .he_border1_caption::before,
.he_border1 .he_border1_caption::after {
  position: absolute;
  content: "";
  opacity: 0;
  -webkit-transition: opacity 0.4s, -webkit-transform 0.4s;
  -moz-transition: opacity 0.4s, -moz-transform 0.4s;
  -o-transition: opacity 0.4s, -o-transform 0.4s;
  transition: opacity 0.4s, transform 0.4s;
}

.he_border1 .he_border1_caption::before {
  top: 8%;
  right: 10%;
  bottom: 8%;
  left: 10%;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  -webkit-transform: scale(0, 1);
  -moz-transform: scale(0, 1);
  -o-transform: scale(0, 1);
  transform: scale(0, 1);
  -webkit-transform-origin: 0 0;
  -moz-transform-origin: 0 0;
  -o-transform-origin: 0 0;
  transform-origin: 0 0;
}

.he_border1 .he_border1_caption::after {
  top: 8%;
  right: 10%;
  bottom: 8%;
  left: 10%;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  -webkit-transform: scale(1, 0);
  -moz-transform: scale(1, 0);
  -o-transform: scale(1, 0);
  transform: scale(1, 0);
  -webkit-transform-origin: 100% 0;
  -moz-transform-origin: 100% 0;
  -o-transform-origin: 100% 0;
  transform-origin: 100% 0;
}

/* .he_border1:hover .he_border1_caption::before,
.he_border1:hover .he_border1_caption::after {
  opacity: 1;
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
} */

.he_border1 .he_border1_caption,
.he_border1 .he_border1_caption > a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -ms-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  overflow: hidden;
  z-index: 1000;
}

.he_border1 .he_border1_caption_h {
  /* font-size: 1.3em; */
  font-weight: 700;
  text-align: center;
  width: 80%;
  position: absolute;
  top: 20%;
  left: 10%;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  overflow: hidden;
  opacity: 1;
  /* font-size: 0.2rem; */
}

.he_border1 .he_border1_caption_p {
  font-size: 1em;
  text-align: center;
  width: 80%;
  position: absolute;
  top: 60%;
  left: 10%;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -ms-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  overflow: hidden;
  opacity: 0;
}

/* .he_border1:hover .he_border1_caption_p {
  top: 45%;
  opacity: 1;
} */

@media (max-width: 992px) {
  .hhh {
    width: 100% !important;
    max-width: 100% !important;
    margin: 20px 0 !important;
    height: 400px !important;
    background-size: cover !important;
  }
  .he_border1 {
    width: 100%;
    max-width: 100%;
    margin: 20px 0 !important;
    height: 400px !important;
    background-size: cover !important;
  }
  .hhhtitle {
    font-size: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news-item copy.vue